import type { ReactNode } from 'react';
import { type CameraSlice, createStoreHooks } from '../../../../canvas/core';
import type { RotationSlice } from '../types';

type RotationTransformDeps = CameraSlice & RotationSlice;

const { useStore } = createStoreHooks<RotationTransformDeps>();

type RotationTransformProps = {
  pageId: number;
  children: ReactNode;
};

export const RotationTransform = ({
  pageId,
  children,
}: RotationTransformProps) => {
  const displayedRotation = useStore(state =>
    state.rotation.selectors.getDisplayedRotation(pageId)
  );

  return (
    <g data-canvas-overlay transform={`rotate(${displayedRotation})`}>
      {children}
    </g>
  );
};
